import { useForm } from "react-hook-form";
import { useProductContext } from "../context/useProductContext";
import {
  deleteJsonHelperWithToken,
  getJsonHelper,
  postFormDataHelper,
  postJsonHelperWithToken,
} from "../../../services/apiService/apiHelper";
import { endpoints } from "../../../services/apiService/endpoint";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const useProductHook = () => {
  const {
    productBinaryImage,
    setProductBinaryImage,
    categoryData,
    setCategoryData,
    parentCategoryData,
    setParentCategoryData,
    count,
    rows,
    isToggleChecked,
    setIsToggleChecked,
    setCount,
    content,
    setContent,
    currentStep,
    setCurrentStep,
    currentCategoryStep,
    setCurrentCategoryStep,
    uploadedImages,
    setUploadedImages,
    uploadCategoryImages,
    setUploadedCategoryImages,
    uploadedImagesAttribute,
    setUploadedAttributeImages,
    productForm,
    setProductForm,
    categoryForm,
    setCategoryForm,
    attributeForm,
    setAttributeForm,
    productTypeForm,
    setProductTypeForm,
    formError,
    setFormError,
    imagesBinary,
    setBinaryImages,
    imagesBinaryAttribute,
    setBinaryImagesAttribute,
    attributeData,
    setAttributeData,
    productTypeData,
    setProductTypeData,
    totalCateogryData,
    setTotalCategoryData,
    setSelectedProductAttributes,
    selectedProductAttributes,
    productData,
    setProductData,
    currentPage,
    setCurrentPage,
  } = useProductContext();

  const navigate = useNavigate();

  // category use hook form
  const {
    register: category_register,
    handleSubmit: category_handleSubmit,
    formState: { errors: category_errors },
    watch: category_watch,
    setValue: category_setValue,
    reset: category_reset,
    setError: category_setError,
  } = useForm({
    mode: "onBlur",
  });

  // product use hook form
  const {
    register: product_register,
    handleSubmit: product_handleSubmit,
    formState: { errors: product_errors },
    watch: product_watch,
    setValue: product_setValue,
    reset: product_reset,
    setError: product_setError,
  } = useForm({
    mode: "onBlur",
  });

  // product type use hook form
  const {
    register: productType_register,
    handleSubmit: productType_handleSubmit,
    formState: { errors: productType_errors },
    watch: productType_watch,
    setValue: productType_setValue,
    reset: productType_reset,
    setError: productType_setError,
  } = useForm({
    mode: "onBlur",
  });

  // attribute use hook form
  const {
    register: attribute_register,
    handleSubmit: attribute_handleSubmit,
    formState: { errors: attribute_errors },
    watch: attribute_watch,
    setValue: attribute_setValue,
    reset: attribute_reset,
    setError: attribute_setError,
  } = useForm({
    mode: "onBlur",
  });

  // Handle toggle change
  const handleToggleChange = () => {
    setIsToggleChecked(!isToggleChecked);
  };

  // Toolbar configuration
  const modules = {
    toolbar: [
      ["bold", "italic", "underline", "strike"], // Text formatting
      [{ header: [1, 2, 3, false] }], // Header options
      [{ list: "ordered" }, { list: "bullet" }], // Lists
      ["link", "image"], // Link and image upload
      ["clean"], // Remove formatting
    ],
  };

  // formats for description
  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "link",
    "image",
  ];

  // Handle changes in the editor
  const handleChange = (value) => {
    // setContent(value);
    console.log("Editor Content:", value); // Logs the editor's content (HTML format)
  };

  const totalSteps = 4; // Total steps in the progress bar
  const categorySteps = 2;

  // Labels for each step
  const stepLabels = ["Product Info", "Media", "Social", "Pricing"];
  const categoryLabels = ["Category Info", "Media"];

  // Function to handle next step
  const handleNext = () => {
    if (currentStep < totalSteps) setCurrentStep(currentStep + 1);
  };

  // category next function
  const handleCategoryNext = () => {
    if (currentCategoryStep < totalSteps) {
      setCurrentCategoryStep(currentCategoryStep + 1);
    }
  };

  // category back function
  const handleCategoryBack = () => {
    if (currentCategoryStep > 1)
      setCurrentCategoryStep(currentCategoryStep - 1);
  };

  // Function to handle previous step
  const handleBack = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };

  // handle file upload function - product
  const handleFileUpload = (event) => {
    const files = Array.from(event.target.files);
    setProductBinaryImage(files);
    const fileURLs = files.map((file) => URL.createObjectURL(file));
    setUploadedImages((prevImages) => [...prevImages, ...fileURLs]);
  };

  // handle file upload function - category
  const handleFileUploadCategory = (event) => {
    console.log("event;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;", event);
    const files = Array.from(event.target.files);
    setBinaryImages(files);
    const fileURLs = files.map((file) => URL.createObjectURL(file));
    console.log(fileURLs, "file URLS:::::::::::::::;");
    console.log("event", event);
    setUploadedCategoryImages((prevImages) => [...prevImages, ...fileURLs]);
  };

  // handle file upload function - attribute
  const handleFileUploadAttribute = (event) => {
    const files = Array.from(event.target.files);
    setBinaryImagesAttribute(files);
    const fileURLs = files.map((file) => URL.createObjectURL(file));
    setUploadedAttributeImages((prevImages) => [...prevImages, ...fileURLs]);
  };

  // handle product form submit
  const handleProductSubmitForm = async (data) => {
    console.log(data, "data in product form");
    try {
      const formData = new FormData();

      // append data on form data
      formData.append("facebook", data.facebook);
      formData.append("instagram", data.instagram);
      formData.append("shopify", data.shopify);
      formData.append("twitter", data.twitter);
      formData.append("optional_acc", data.optional_acc);
      formData.append("is_featured", data.is_featured);
      formData.append("product_category", data.product_category);
      formData.append("product_description", data.product_description);
      formData.append("product_name", data.product_name);
      formData.append("product_price", data.product_price);
      formData.append("product_qty", data.product_qty);
      formData.append("product_sku", data.product_sku);
      formData.append("product_status", data.product_status);
      formData.append("product_type", data.product_type);
      formData.append("is_customer_requirement", data.is_customer_requirement);
      formData.append("product_placement", data.product_placement);

      console.log('produc ---placement', data.product_placement);
      if (data.product_placement == "top_trending_gifts") {
        formData.append("top_trending_section", data.top_trending_section);
      }

      // with customer requirement
      if (data.is_customer_requirement === true) {
        console.log("data in customer requirement", data);
        formData.append("addition_req_count", data.requirement_count);

        // handle text type and customer text
        for (let i = 0; i < parseInt(data.requirement_count); i++) {
          console.log("in loop");
          let text = `text_${i}`;
          let type = `requirement_type_${i}`;
          let customerText = `requirement_customerDisplay_${i}`;

          if (data[text]) {
            formData.append(text, data[text]);
          }

          if (data[type]) {
            formData.append(type, data[type]);
          }

          if (data[customerText]) {
            formData.append(customerText, data[customerText]);
          }
        }
      }

      // append images on form data
      if (productBinaryImage.length !== 0) {
        productBinaryImage.forEach((image) => {
          formData.append("images", image);
        });
      }

      // append attributes on form data
      if (selectedProductAttributes.length !== 0) {
        selectedProductAttributes.forEach((attribute) => {
          formData.append("product_attributes", attribute);
        });
      }

      const response = await postFormDataHelper(
        endpoints.createProduct,
        formData
      );

      console.log("response in product form submit", response);

      if (response.data.status === true) {
        toast.success(response.data.message, { autoClose: 800 });
        product_reset();
        setProductBinaryImage([]);
        setUploadedImages([]);
        setSelectedProductAttributes([]);
        setCurrentStep(1);
        setCount(0);
      } else {
        toast.error(response.data.message);
      }
    } catch (err) {
      toast.error(err.response.data.message, { autoClose: 800 });
      console.log(err, "error in product form submit");
    }
  };

  // fetch all categories
  const fetchAllCategories = async () => {
    try {
      const response = await getJsonHelper(endpoints.getAllCategory);
      if (response?.data?.status === true) {
        console.log("All categories:================", response.data.data);
        setParentCategoryData(response?.data?.data?.parentCategory);
        setCategoryData(response?.data?.data?.childCategory);
        setTotalCategoryData(response?.data?.data?.totalCategory);
      } else {
        console.log("error in fetching all categories");
      }
    } catch (err) {
      console.log(err, "error in fetching all categories");
    }
  };

  // category form validation
  const checkCategoryFormValues = () => {
    if (
      category_watch("category_name") === "" ||
      category_watch("category_description") === "" ||
      category_watch("is_parent") === ""
    ) {
      category_setError("category_name", {
        type: "manual",
        message: "Category name is required",
      });
      category_setError("category_description", {
        type: "manual",
        message: "Category description is required",
      });
      category_setError("is_parent", {
        type: "manual",
        message: "Is parent is required",
      });

      return false;
    }
    return true;
  };

  // attribute form validation
  const checkAttributeUnfilledValue = () => {
    if (
      attribute_watch("attributes_name") === "" ||
      attribute_watch("attributes_value") === "" ||
      imagesBinaryAttribute.length === 0
    ) {
      attribute_setError("name", {
        type: "manual",
        message: "* Attribute Name is required",
      });
      attribute_setError("value", {
        type: "manual",
        message: "* Attribute Value is required",
      });
      attribute_setError("attribute_unique_id", {
        type: "manual",
        message: "* Attribute Unique Id is required",
      });

      return false;
    }
    return true;
  };

  // product form validation
  const checkProductFormValues = () => {
    console.log("current step", currentStep);
    if (currentStep === 1) {
      if (
        product_watch("product_name") === "" ||
        product_watch("product_description") === "" ||
        product_watch("product_sku") === "" ||
        product_watch("product_qty") === "" ||
        product_watch("product_category") === ""
      ) {
        product_setError("product_name", {
          type: "manual",
          message: "Product name is required",
        });
        product_setError("product_description", {
          type: "manual",
          message: "Product description is required",
        });
        product_setError("product_sku", {
          type: "manual",
          message: "Product sku is required",
        });
        product_setError("product_qty", {
          type: "manual",
          message: "Product quantity is required",
        });
        return false;
      }
      return true;
    }
    if (currentStep === 2) {
      console.log("uploaded images", uploadedImages);
      console.log("uploaded images length", uploadedImages.length);
      if (!uploadedImages) {
        toast.error("Please upload images", { autoClose: 2000 });
        return true;
      }
      return true;
    }
    if (currentStep === 3) {
      return true;
    }
    if (currentStep === 4) {
      if (
        product_watch("product_price") ||
        product_watch("is_featured") ||
        product_watch("product_status") ||
        product_watch("product_type") ||
        product_watch("is_customer_requirement")
      ) {
        product_errors.product_price = {
          type: "manual",
          message: "Product price is required",
        };
        product_errors.is_featured = {
          type: "manual",
          message: "Is featured is required",
        };
        product_errors.product_status = {
          type: "manual",
          message: "Product status is required",
        };
        product_errors.product_type = {
          type: "manual",
          message: "Product type is required",
        };
        product_errors.is_customer_requirement = {
          type: "manual",
          message: "Customer requirement is required",
        };

        return false;
      }
    }
    setProductForm({
      ...productForm,
      product_name: product_watch("product_name"),
      product_description: product_watch("product_description"),
      product_sku: product_watch("product_sku"),
      product_qty: product_watch("product_qty"),
      product_category: product_watch("product_category"),
      product_price: product_watch("product_price"),
      is_featured: product_watch("is_featured"),
      product_status: product_watch("product_status"),
      product_type: product_watch("product_type"),
      is_customer_requirement: product_watch("is_customer_requirement"),
    });
    return true;
  };

  // category form submit function
  const categoryFormSubmit = async (data) => {
    console.log("data in category form submit", data);
    try {
      const formData = new FormData();
      formData.append("category_name", data.category_name);
      formData.append("category_description", data.category_description);
      formData.append("is_parent", data.is_parent);
      formData.append("category_level", data.category_level);

      if (data.is_parent === "false") {
        formData.append("parent_category_id", data?.parent_category_id);
      }

      imagesBinary.forEach((image) => {
        console.log("images", image);
        formData.append("images", image);
      });

      const response = await postFormDataHelper(
        endpoints.createCategory,
        formData
      );
      console.log("response in category form submit", response);

      if (response.data.status === true) {
        console.log("Category created successfully");
        toast.success(response.data.message);
        setCurrentCategoryStep(1);
        setUploadedCategoryImages([]);
        setBinaryImages([]);
        category_reset();
        fetchAllCategories();
      } else {
        toast.error(response.data.message);
      }
    } catch (err) {
      toast.error(err.response.data.message, { autoClose: 800 });
      console.log(err, "error in category form submit");
    }
  };

  // attribute form submit function
  const attributeFormSubmit = async (data) => {
    console.log("attribute data", data);
    try {
      const formData = new FormData();
      formData.append("attributes_name", data.attributes_name);
      formData.append("attributes_value", data.attributes_value);
      formData.append("attribute_unique_id", data.attribute_unique_id);

      imagesBinaryAttribute.forEach((image) => {
        formData.append("images", image);
      });

      const response = await postFormDataHelper(
        endpoints.createAttribute,
        formData
      );

      console.log("response in attribute form submit", response);

      if (response?.data?.status === true) {
        toast.success(response.data.message, { autoClose: 2000 });
        setUploadedAttributeImages([]);
        setBinaryImagesAttribute([]);
        attribute_reset();
      }
    } catch (err) {
      toast.error(err.response.data.message, { autoClose: 800 });
      console.log(err, "error in attribute form submit");
    }
  };

  // fetch all attributes
  const fetchAttributes = async () => {
    try {
      const response = await getJsonHelper(endpoints.getAllAttributes);
      console.log("response in fetch attributes", response);

      if (response?.data?.status === true) {
        console.log("All attributes:================", response.data.data);
        setAttributeData(response?.data?.data);
      }
    } catch (err) {}
  };

  // create product type
  const createProductType = async (data) => {
    console.log("data in create product type", data);
    try {
      if (Object.keys(data).length === 0) {
        toast.error("Please fill the form", { autoClose: 2000 });
        return;
      }

      const response = await postJsonHelperWithToken(
        endpoints.createProductType,
        data
      );
      console.log("response in create product type", response);

      if (response?.data?.status === true) {
        toast.success(response.data.message, { autoClose: 2000 });
        productType_reset();
      }
    } catch (err) {
      toast.error(err.response.data.message, { autoClose: 800 });
      console.log(err, "error in create product type");
    }
  };

  // fetch all product type
  const fetchAllProductType = async () => {
    try {
      const response = await getJsonHelper(endpoints.getAllProductType);

      if (response?.data?.status === true) {
        console.log("All product type:================", response.data.data);
        setProductTypeData(response?.data?.data);
      }
    } catch (err) {
      console.log(err, "error in fetching all product type");
    }
  };

  const fetchAllProductsTableData = async () => {
    try {
      const response = await getJsonHelper(
        `${endpoints.getAllProducts}?page=${currentPage}&limit=10`
      );

      if (response?.data?.status === true) {
        console.log("All products:================", response.data.data);
        setProductData(response?.data?.data);
      }
    } catch (err) {
      console.log("error in fetching all products", err);
    }
  };

  // all details data would be here
  const productHeaders = [
    {
      Header: "SKU",
      accessor: "product_sku",
    },
    {
      Header: "Category",
      accessor: "product_category",
    },
    {
      Header: "Price",
      accessor: "product_price",
    },
    {
      Header: "Status",
      accessor: "product_status",
    },
  ];

  // category headers
  const categoryHeaders = [
    {
      Header: "Is Parent",
      accessor: "is_parent",
    },
    {
      Header: "Parent Category",
      accessor: "parent_category_id",
    },
  ];

  // attributes headers
  const attributeHeaders = [
    {
      Header: "Name",
      accessor: "attributes_name",
    },
    {
      Header: "Unique Id",
      accessor: "attribute_unique_id",
    },
    {
      Header: "Value",
      accessor: "attributes_value",
    },
    {
      Header: "action",
      accessor: "action",
    },
  ];

  // product type headers
  const productTypeHeaders = [
    {
      Header: "Name",
      accessor: "product_type_name",
    },
    {
      Header: "count (product)",
      accessor: "count",
    },
    {
      Header: "action",
      accessor: "action",
    },
  ];

  const deleteProduct = async (id) => {
    try {
      const response = await deleteJsonHelperWithToken(
        `${endpoints.deleteProduct}/${id}`
      );
      if (response?.data?.status === true) {
        toast.success(response.data.message, { autoClose: 2000 });
        fetchAllProductsTableData();
      }
    } catch (err) {
      console.log("error in deleting product", err);
    }
  };

  const deleteCategory = async (id) => {
    try {
      const response = await deleteJsonHelperWithToken(
        `${endpoints.deleteCategory}/${id}`
      );
      if (response?.data?.status === true) {
        toast.success(response.data.message, { autoClose: 2000 });
        fetchAllCategories();
      }
    } catch (err) {
      console.log("error in deleting category", err);
    }
  };

  const handleEditButton = (rowData, tableType) => {
    if (tableType === "product") {
      console.log("row data in product", rowData);
      navigate("/admin/editProduct", {
        state: { rowData, tableType },
        replace: true,
      });
    } else if (tableType === "category") {
    } else if (tableType === "attribute") {
    } else if (tableType === "productType") {
    }
  };

  return {
    selectedProductAttributes,
    setSelectedProductAttributes,
    categoryHeaders,
    createProductType,
    checkCategoryFormValues,
    product_errors,
    product_register,
    product_handleSubmit,
    product_watch,
    product_setValue,
    product_reset,
    category_register,
    category_handleSubmit,
    category_errors,
    category_watch,
    category_setValue,
    category_reset,
    handleToggleChange,
    modules,
    formats,
    handleChange,
    totalSteps,
    categorySteps,
    stepLabels,
    categoryLabels,
    handleNext,
    handleCategoryNext,
    handleCategoryBack,
    handleBack,
    handleFileUpload,
    handleFileUploadCategory,
    handleFileUploadAttribute,
    count,
    rows,
    isToggleChecked,
    setIsToggleChecked,
    setCount,
    content,
    setContent,
    currentStep,
    setCurrentStep,
    currentCategoryStep,
    setCurrentCategoryStep,
    uploadedImages,
    setUploadedImages,
    uploadCategoryImages,
    setUploadedCategoryImages,
    uploadedImagesAttribute,
    setUploadedAttributeImages,
    formError,
    productForm,
    handleProductSubmitForm,
    fetchAllCategories,
    categoryData,
    parentCategoryData,
    categoryFormSubmit,
    attribute_handleSubmit,
    attribute_errors,
    attribute_register,
    attribute_watch,
    attribute_setValue,
    attribute_reset,
    attributeFormSubmit,
    checkAttributeUnfilledValue,
    attributeData,
    setAttributeData,
    fetchAttributes,
    productType_register,
    productType_handleSubmit,
    productType_errors,
    productType_watch,
    productType_setValue,
    productType_reset,
    productTypeData,
    setProductTypeData,
    fetchAllProductType,
    checkProductFormValues,
    totalCateogryData,
    setTotalCategoryData,
    setSelectedProductAttributes,
    selectedProductAttributes,
    fetchAllProductsTableData,
    productHeaders,
    productData,
    currentPage,
    setCurrentPage,
    deleteProduct,
    handleEditButton,
    deleteCategory,
  };
};

export default useProductHook;
